import { ChangeEvent, FocusEvent } from 'react';

import RegionSelect, {
	RegionSelectProps,
} from 'components/standard/RegionSelect';
import { useInput } from 'components/LWForm/LWForm';

const HookedRegionSelect = ({
	helperText,
	name,
	onBlur,
	onChange,
	error: errorProp,
	required,
	...rest
}: RegionSelectProps) => {
	const { value, onValueChange, error, validateSimple } = useInput(name!);

	if (!name) {
		return null;
	}

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		if (!event.target) {
			return;
		}

		if (onChange) {
			onChange(event);
		}

		onValueChange(event.target.value);

		// validate on input change only if there is an existing error
		if (!error) {
			return;
		}

		validateSimple(value, required);
	};

	const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
		if (!event.target) {
			return;
		}

		if (onBlur) {
			onBlur(event);
		}

		validateSimple(value, required);
	};

	return (
		<RegionSelect
			helperText={error || errorProp || helperText}
			name={name}
			onBlur={handleBlur}
			onChange={handleChange}
			error={Boolean(error || errorProp)}
			required={required}
			{...rest}
			value={value}
		/>
	);
};

export default HookedRegionSelect;
